import type { GatsbyLocation } from "../../../@alexandrudanpop/byfolio-theme/src/compat/gatsby-public-api"
import {
  AnalyticsConsentStore,
  type AnalyticsConsentChoice,
} from "./consent-store"
import {
  createBrowserAnalyticsEnvironment,
  GoogleAnalyticsController,
} from "./google-analytics"

const analyticsEnabled =
  process.env.NODE_ENV === "production" ||
  process.env.GATSBY_ANALYTICS_TEST === "true"

const getBrowserStorage = (): Storage | undefined => {
  if (typeof window === "undefined") return undefined

  try {
    return window.localStorage
  } catch {
    return undefined
  }
}

const consentStore = new AnalyticsConsentStore(
  getBrowserStorage(),
  typeof window === "undefined" ? undefined : window
)
const analytics = new GoogleAnalyticsController(
  analyticsEnabled,
  typeof window === "undefined"
    ? undefined
    : createBrowserAnalyticsEnvironment()
)
let initialized = false
const consentReviewListeners = new Set<() => void>()

export const initializeAnalyticsConsent = (): AnalyticsConsentChoice => {
  if (initialized) return consentStore.getChoice()

  analytics.initialize()
  const choice = consentStore.initialize()
  analytics.applyConsent(choice)
  consentStore.subscribe(nextChoice => {
    analytics.applyConsent(nextChoice)
  })
  initialized = true
  return choice
}

export const getAnalyticsConsentChoice = (): AnalyticsConsentChoice =>
  initialized ? consentStore.getChoice() : initializeAnalyticsConsent()

export const setAnalyticsConsentChoice = (
  choice: Exclude<AnalyticsConsentChoice, "unset">
): void => {
  initializeAnalyticsConsent()
  consentStore.setChoice(choice)
}

export const subscribeToAnalyticsConsent = (
  listener: (choice: AnalyticsConsentChoice) => void
): (() => void) => consentStore.subscribe(listener)

export const requestAnalyticsConsentReview = (): void => {
  consentReviewListeners.forEach(listener => {
    listener()
  })
}

export const subscribeToAnalyticsConsentReview = (
  listener: () => void
): (() => void) => {
  consentReviewListeners.add(listener)
  return () => consentReviewListeners.delete(listener)
}

export const recordAnalyticsRoute = (location: GatsbyLocation): void => {
  initializeAnalyticsConsent()
  analytics.recordRoute(location)
}
